<template>
    <div id="scrolla" v-if="$store.state.categoriesLoaded&&listingLoaded&&$store.state.associationsLoaded" style="background-color:#fff" v-scroll="onScroll">
        
        <v-container pa-0 style="max-width:1170px">
            <div class="header-container" :style="{'background-image':'url('+listing.headerUrl || header+')'}"></div>            
            <v-btn style="z-index:99; margin-top:-20px;" color="primary" class="back-button" :to="{name:'Home'}">
                Back
            </v-btn> 
        </v-container>

        <v-container  style="max-width:1170px" grid-list-xl class="listing-content mb-5">
            <v-layout row wrap>
                
                <v-flex xs12 md3 class="executive-sidebar mt-5 hidden-sm-and-down">
                     <v-layout row wrap style="background-color:#eee" class="pa-3">                          
                        <v-flex xs12 md12 v-if="listing.executiveUrl">
                            <div class="exec-photo-container" :style="{'background-image':'url('+listing.executiveUrl || executive+')'}"></div>                   
                            <h3 class="mt-1 mb-2">{{listing.execName}}</h3>
                            <p class="subheading mb-2" style="font-size:1.1em"><em>{{listing.execPostion}}</em></p>
                            <v-divider class="my-3" style="border-color:#aaa!important"></v-divider>
                            <p>{{listing.execMission}}</p>
                        </v-flex>
                    </v-layout>    
                    
                    <v-layout row wrap v-if="showAssociations">
                        <v-flex xs12>
                            <h2 class="mt-5">Proud Member Of</h2>
                        </v-flex>                   
                        <v-flex xs12 v-for="(association, assocKey, index) in listing.associations" :key="assocKey" 
                        v-if="$store.state.associations[assocKey]&&listing.associations[assocKey] === true">
                            <listing-association :association-key="assocKey"></listing-association>                                               
                        </v-flex>
                                             
                    </v-layout>
                    <v-layout>
                        <div style="width:100%; margin:auto; padding:15px;text-align:center;">
                            <div v-if="listing.podcast === undefined">  
                            </div>
                            <div v-else-if="listing.podcast === ''">
                            </div>
                            <div v-else-if="listing.podcastUrl === undefined || listing.podcastUrl === ''">
                                <div @click="podcast = true">
                                    <img style="padding-left: 0px;width:80%;margin:auto;" 
                                    :src="'https://firebasestorage.googleapis.com/v0/b/gtconnect2019.appspot.com/o/listings%2F00SUZwWUpqNhH3MFfe5x%2FGT_COnnect_Pocast_Listen_Now_Image.png?alt=media&token=6e9a4217-eb6b-4e4b-8801-9b06e03d8d2a'">
                                </div>
                            </div>
                            <div v-else>
                                <div @click="podcast = true">
                                    <img style="padding-left: 0; width: 100%; max-width:" 
                                    :src="listing.podcastUrl">
                                </div>
                            </div>
                        </div>
                    </v-layout>
                </v-flex>

                <v-flex xs12 md9 class="main-container" pt-2>
                    <v-layout row wrap>
                        <v-flex xs7 md4>
                             <div class="logo-container" :style="{'background-image':'url('+listing.logoUrl || header+')'}"></div>
                        </v-flex>
                        <v-flex xs12 md10 offset-md1 class="award-container" :style="'background-image:url('+award+')'">
                        </v-flex>
                    </v-layout>

                    <v-dialog v-model="podcast"  max-width="500px">
                        <div style="width:100%;text-align:right;position: absolute; top: 0; right: 0;z-index:99">
                            <v-icon style="background-color:#fff;margin-left: 0;width: 50px;height: 40px;margin-left: auto;text-align: right;justify-content: center;" @click="podcast = false">close</v-icon>
                        </div>
                        <v-card>
                            <v-card-title primary-title >
                                <span style="width: 460px;" v-html="listing.podcast"></span>
                            </v-card-title>
                        </v-card>
                    </v-dialog>

                    <v-layout row wrap align-baseline>
                        <v-flex grow>                            
                            <h1 class="company-name"> {{listing.companyName}}</h1>                            
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap align-center v-if="website||facebook||twitter||linkedin||listing.requestButton">                          
                        <v-btn color="#100429" dark v-if="website" :href="website" target="_blank">Visit Website</v-btn>   
                        <v-spacer v-if="!listing.requestButton"></v-spacer>                        
                        <v-btn icon color="#3b5998" class="elevation-3" v-if="facebook" :href="facebook" target="_blank">
                            <i style="color:#fff" class="fab fa-facebook"></i>
                        </v-btn>
                        <v-btn icon color="#1da1f2" class="elevation-3" v-if="twitter" :href="twitter" target="_blank">
                            <i style="color:#fff" class="fab fa-twitter"></i>
                        </v-btn>
                        <v-btn icon color="#0e76a8" class="elevation-3" v-if="linkedin" :href="linkedin" target="_blank">
                            <i style="color:#fff" class="fab fa-linkedin"></i>
                        </v-btn> 
                        <v-spacer v-if="listing.requestButton"></v-spacer>      
                        <v-btn color="primary" @click="sending = true" v-if="listing.requestButton">Request Free Information</v-btn>                                         
                    </v-layout>

                    <v-divider v-if="website||facebook||twitter||linkedin||listing.requestButton" class="mb-4 mt-3"></v-divider>

                    <v-layout row wrap>
                        <v-flex xs12>
                            <h2 class="mt-3">About us</h2>
                            <p>{{listing.aboutUs}}</p>    
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap class="hidden-md-and-up mt-5 ">                          
                        <v-flex xs12 md12 v-if="listing.executiveUrl">
                            <div class="exec-photo-container" :style="{'background-image':'url('+listing.executiveUrl || executive+')'}"></div>                   
                        </v-flex>
                        <v-flex xs12 md12>
                            <h3>{{listing.execName}}</h3>
                            <p class="subheading">{{listing.execPostion}}</p>
                            <p>{{listing.execMission}}</p>
                        </v-flex>
                    </v-layout>    
                    <v-layout>
                        
                    </v-layout>
                    <v-layout row wrap v-if="Object.keys(listing.associations || {}).length" class="hidden-md-and-up mt-5">
                        <v-flex xs12>
                            <h2 class="mt-3">Proud Member Of</h2>
                        </v-flex>                   
                        <v-flex xs6 v-for="(association, assocKey, index) in listing.associations" :key="assocKey" 
                        v-if="$store.state.associations[assocKey]&&listing.associations[assocKey] === true">
                            <listing-association :association-key="assocKey"></listing-association>                                               
                        </v-flex>                     
                    </v-layout>

                    <v-layout row wrap v-if="Object.keys(listing.services || {}).length">
                        <v-flex xs12>
                            <h2 class="mt-5">Services</h2>
                        </v-flex>           
                    </v-layout>
                    <v-layout  class="mb-4 py-4 px-3" style="border:1px solid #bbb; border-radius:7px" row wrap v-for="(servicesGroup, groupKey, index) in $store.state.categories[listing.category].categoryServicesGroups" :key="groupKey">
                        <v-flex xs12 py-0>
                            <h3 class="my-0 group-name pa-0">{{servicesGroup.servicesGroupName}}</h3>
                        </v-flex>
                        <v-flex xs6 md4 py-0 v-for="(service, serviceKey, index) in servicesGroup.services" :key="serviceKey">
                            <v-checkbox readonly class="service-name" color="primary" hide-details :label="service.serviceName" v-model="checked"
                            v-if="(listing.services[groupKey]&&listing.services[groupKey].services[serviceKey].checked)">
                            </v-checkbox>      
                            <v-checkbox readonly class="service-name" color="primary" hide-details :label="service.serviceName" v-model="unchecked"
                            v-else>
                            </v-checkbox>                          
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap v-if="showProfile">
                        <v-flex xs12>
                            <h2 class="mt-5">Profile</h2>
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap v-if="showProfile" class="py-2 px-3" style="border:1px solid #bbb; border-radius:7px">
                        <v-flex xs12 md6  v-for="(field, name, index) in listing.fields" :key="name" v-if="field.value" >
                            <h5 class="field-name">{{field.fieldName}}</h5>
                            <span class="field-value">{{field.value}}</span>
                        </v-flex> 
                    </v-layout>


                    <v-layout row wrap>
                        <v-flex xs12 md4 v-if="listing.address" class="pr-5">
                            <h2 class="mt-5 mb-2">Address</h2>
                            <span>
                            {{listing.address.headquarters}}<br>
                            {{listing.address.city}},&nbsp;{{listing.address.state}}                      
                            {{listing.address.zip}}<br>
                            {{listing.address.country}}</span>
                        </v-flex> 
                        <v-flex xs12 md4 v-if="listing.phone" class="pr-5">
                            <h2 class="mt-5 mb-2">Phone</h2>
                            <v-icon>phone</v-icon><span>{{listing.phone}}</span>
                        </v-flex> 
                        <v-flex xs7 md4 class="pt-5">
                            <div class="logo-container" :style="{'background-image':'url('+listing.logoUrl || header+')'}"></div>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>


        </v-container>      

        <v-divider class="my-5"></v-divider>

        <v-slide-y-reverse-transition>
        <v-btn v-if="listing.requestButton&&(offsetTop>400)" style="z-index:99" color="primary" round class="save-button" @click="sending = true" :loading="saving" fixed bottom right>
            Request Free Information
        </v-btn> 
        </v-slide-y-reverse-transition>

        <v-dialog v-model="sending" scrollable max-width="800px" :overlay="false" transition="dialog-transition" v-if="sending">
            <v-stepper non-linear :value="currentStep" style="width:100%">
                <img src="http://www.globaltrademag.com/wp-content/uploads/2019/06/2019-06-19.png" style="width:100%" alt="">
                <v-stepper-header>
                    <v-stepper-step step="1" :complete="currentStep>2">Describe Your Challenge</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step step="2" :complete="currentStep>3">Contact Information</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step step="3" :complete="currentStep>4">Complete Request</v-stepper-step>
                </v-stepper-header>

                <v-stepper-items>
                    <v-stepper-content step="1">                        
                        <v-form>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <h2>WHAT ARE YOU LOOKING FOR?</h2>
                                </v-flex>
                                <v-flex xs12 px-3><v-textarea v-model="challenge" class="fill-height-textarea" textarea label="Describe your challenge"></v-textarea></v-flex>
                            </v-layout>
                        </v-form>
                         <v-layout row wrap>
                            <v-spacer></v-spacer>
                            <v-flex xs12 md6 px-3>
                                <v-btn :disabled="challenge==''" color="primary" block @click="currentStep = 2">Next</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-stepper-content>
                    
                    <v-stepper-content step="2">
                        <v-form v-model="contactValid">
                            <v-layout row wrap align-baseline>
                                <v-flex xs12>
                                    <h2>What's your best contact information??</h2>
                                </v-flex>                                
                                <v-flex xs12 md6 px-3><v-text-field label="Full Name" v-model="name" :rules="$rules.name"></v-text-field></v-flex>
                                <v-flex xs12 md6 px-3><v-text-field label="Email" v-model="email" :rules="$rules.email"></v-text-field></v-flex>
                                <v-flex xs12 md6 px-3><v-text-field label="Company Name" v-model="company" :rules="$rules.company"></v-text-field></v-flex>
                                <v-flex xs12 md6 px-3><v-text-field label="Phone Number" v-model="phone" :rules="$rules.phone"></v-text-field></v-flex>
                                <v-flex xs12 md6 px-3><v-text-field label="Zip Code" v-model="zip" :rules="$rules.zip"></v-text-field></v-flex>
                                <v-flex xs12 md6 px-3>
                                    <v-btn color="primary" :disabled="!contactValid" block @click="currentStep = 3">Next</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-stepper-content>

                    <v-stepper-content step="3">
                        <v-layout row wrap>
                            <v-flex xs12>
                                <h2>Last Step!</h2>
                                <p>Please let us know what type of information you would like to receive</p>
                            </v-flex>
                            <v-flex xs12 md6 px-3>
                                <p class="mt-3">We never, EVER share or sell your information, email or phone number, to anyone other than the specific businesses you have requested. By submitting this form, you agree to receive text messages from Global Trade Magazine and the businesses you've requested more information from. View our  <a href="#" @click="terms = true">Terms</a> and <a href="#" @click="privacy = true">Privacy Policy</a>.</p>
                            </v-flex>
                            <v-flex xs12 md6 px-3>
                                <v-switch color="primary" v-model="quotes" label="Free Information"></v-switch>
                                <v-switch color="primary" v-model="information" label="Free Quotes"></v-switch>
                                <v-btn color="primary" block @click="sendRequests()">Submit your request</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-stepper-content>
                </v-stepper-items>

            </v-stepper>
        </v-dialog>

        <v-dialog v-model="sentSuccessfully" style="max-width:500px" max-width="500px">
            <v-card class="text-xs-center pa-3">
                <h2>Thank you for your request! We are connecting you with top providers as we speak.</h2>
                <img class="sent-animation mt-4" src="http://www.globaltrademag.com/wp-content/uploads/2019/06/fly.gif">
            </v-card>
        </v-dialog>


        <privacy-policy v-if="privacy" v-model="privacy"></privacy-policy>
        <terms v-if="terms" v-model="terms"></terms>
    </div>
</template>


<script>
import firebase from '@/firebase.js';
import ListingAssociation from '@/components/items/ListingAssociation.vue';

export default {
    data() {
        return {
            saving:false,
            listingLoaded:false,
            listing:{},
            listingId:this.$route.params.id,
            award:'',
            editingHeader:false,
            editingLogo: false,
            editingExecutive:false,
            sending:false,
            sentSuccessfully:false,
            privacy:false,
            terms:false,            
            requests:{},
            contactValid:false,
            challenge:'',
            name:'',
            company:'',
            zip:'',
            email:'',
            phone:'',
            quotes:true,
            information:true,
            currentStep:0,
            checked:true,
            unchecked:false,
            offsetTop:0,
            podcast: false
        }
    },

    created() {        
        this.$store.dispatch('getCategories');
        this.$store.dispatch('getAssociations');
        firebase.firestore().collection('listings').doc(this.listingId).get().then((doc)=>{
            this.listing = doc.data();
            if(!this.listing.services) {this.listing.services = {}}
            if(!this.listing.fields) {this.listing.fields = {}}
            this.listingLoaded = true;
            this.requests[this.listingId] = this.listing;
            if (this.listing.award) {
            firebase.storage().ref().child('/awards/'+this.listing.award).child('/badge.png').getDownloadURL().then((url)=>{
                this.award = url;
            });
        }
        });
    },

    methods:{
        sendRequests() {
            var requestsNumber = Object.keys(this.requests).length;
            var savedNumber = 0;
            Object.keys(this.requests).forEach(requestKey=>{
                var listing = this.requests[requestKey];
                var newRequest = {
                    date:Date.now(),
                    toUserId:listing.userId,
                    toUserEmail:listing.userEmail,
                    category:listing.category,
                    toCompanyName:listing.companyName,
                    fromName:this.name,
                    fromEmail:this.email,
                    fromCompany:this.company,
                    fromPhone:this.phone,
                    fromZip:this.zip,
                    challenge:this.challenge,
                    quotes:this.quotes,
                    information:this.information,
                    completed:false,
                    favorite:false
                }
                console.log(newRequest);
                firebase.firestore().collection('requests').add(newRequest).then(docref=>{
                    savedNumber++;
                    if (requestsNumber == savedNumber) {
                        this.currentStep = 0;
                        this.sending = false;
                        this.sentSuccessfully = true;                        
                    }
                    console.log(docref.id);
                })
            });
        },

        showGroup(key) {
            let hasService = false
            Object.keys(this.listing.services[key].services).forEach(s=>{
                if (this.listing.services[key].services[s].checked) {
                    hasService = true;
                }
            });
            return hasService;
        },

        onScroll (e) {
            this.offsetTop = window.pageYOffset || document.documentElement.scrollTop;
            console.log(e.target);
        }
    },

    computed:{
        website() {
            let exp = /(ftp|http|https):\/\/?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/;
            if (exp.test(this.listing.website)) {
                return this.listing.website
            }
            return null;
        },

        facebook() {
            let exp = /(ftp|http|https):\/\/?(?:www\.)?(mbasic.facebook|m\.facebook|facebook|fb)\.(com|me)\/(?:(?:\w\.)*#!\/)?(?:pages\/)?(?:[\w\-\.]*\/)*([\w\-\.]*)/ig;
            if (exp.test(this.listing.facebook)) {
                return this.listing.facebook
            }
            return null;
        },

        twitter() {
            let exp = /(ftp|http|https):\/\/?(?:www\.)?twitter\.com\/(?:(?:\w)*#!\/)?(?:pages\/)?(?:[\w\-]*\/)*([\w\-]*)/;
            if (exp.test(this.listing.twitter)) {
                return this.listing.twitter
            }
            return null;
        },

        linkedin() {
            let exp = /(ftp|http|https):\/\/?(?:www\.)?linkedin.com(\w+:{0,1}\w*@)?(\S+)(:([0-9])+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
            if (exp.test(this.listing.linkedin)) {
                return this.listing.linkedin
            }
            return null;
        },

        showProfile() {
            var show = false;
            Object.keys(this.listing.fields).forEach((field)=>{
                if(this.listing.fields[field].value) {
                    show = true;
                }
            });
            return show;
        },

        showAssociations() {
            var show = false;
            if (this.listing.associations) {
                Object.keys(this.listing.associations).forEach((association)=>{
                    if(this.listing.associations[association] === true) {
                        show = true;
                    }
                });            
            }            
            return show;
        }
    },

    components:{
        ListingAssociation
    },
}
</script>


<style>
    h2 {
        font-weight: 500;
        color: #f6a027;
    }

    .company-name {
        font-weight: bold;
        color: #333;
    }

     .award-container {
        width: 100%;
        padding-top: 100%;
        background-position: 50%;
        background-size: contain;
    }


    .group-name {
        color: #555;
        width: 100%;
        font-size: 1.3em;
    }

    .service-name{
        font-weight: 500;
    }

    .listing-content{
        font-size: 1.1em;
    }

    .v-btn.primary {
        color: #100429!important;
    }


    .logo-container {
        position: relative;
        height: 0;
        overflow: hidden;
        padding-top:66%;
        background-size: contain;
        background-position: 50%;
    }

    .header-container {
        position: relative;
        height: 0;
        overflow: hidden;
        padding-top:23%;
        background-size: cover;
        background-position: 50%;
    }

    .exec-photo-container {
        padding-top: 120%;
        background-position: 50%;
        background-size: cover;
    }

    .contact-icon {
        font-size: 1.4em;
        margin-right:15px;
        color: #f6a027;
    }


    .edit-header-button {
        position: absolute;
        top: 15px;
        right: 15px;
    }

    .v-btn.narrow {
        min-width: 0;
    }

    .company-name textarea{
        font-size: 1.6em;
        font-weight: 800;
        line-height: 1.3em; 
    }

    .sidebar-container {
        margin-top: -70px;
    }

    .profile-sidebar {
        padding-bottom: 20px;
    }

    
    .main-container {
        padding-left: 70px!important;
    }

    .association-logo-container {
        width: 100%;
        padding-top: 50%;
        background-size: contain;
        background-position: 50%;
    }

    .profile-sidebar .v-card__text {
        padding: 0 30px;
    }

    .fill-height-textarea {
        height: 100%;
    }

    
    .fill-height-textarea .v-input__slot {
        height: 100%;
    }

    .fill-height-textarea .v-input__control {
        height: 100%;
    }


    .fill-height-textarea .v-text-field__slot {
        height: 100%;
    }

    .fill-height-textarea textarea {
        height: 100%;
    }

    .active-assoc{
        background-color: #f6a027;
    }

    .back-button {
        position: relative;
    }

    .field-name, .field-value {
        font-size: 1.05em;
    }

    .field-name {
        font-weight: bold;
    }
    .v-dialog{
        position: relative;
    }

    
    @media (max-width: 768px) {
        .sidebar-container {
            margin-top: 20px;
        }
        .main-container {
            padding-left: 8px!important;
        }
    }

</style>